/**
 * ClaimedLeadBanner Component
 * Shows a banner after claiming a lead with link to view contact
 */

import React from 'react';
import { CheckCircle, X } from 'lucide-react';

interface ClaimedLeadBannerProps {
  contactId: string;
  contactName: string | null;
  onDismiss: () => void;
  onViewContact?: () => void;
}

export const ClaimedLeadBanner: React.FC<ClaimedLeadBannerProps> = ({
  contactId,
  contactName,
  onDismiss,
  onViewContact,
}) => {
  const handleViewContact = () => {
    onViewContact?.();
    onDismiss();
  };

  return (
    <div className="px-4 py-3 bg-green-50 dark:bg-green-900/20 border-b border-green-200 dark:border-green-700/30 flex items-center justify-between animate-in slide-in-from-top-2 duration-200">
      <div className="flex items-center gap-2">
        <CheckCircle className="w-5 h-5 text-green-600 dark:text-green-400" />
        <span className="text-sm text-green-800 dark:text-green-200">
          <strong>{contactName || 'Lead'}</strong> claimed!
        </span>
      </div>
      <div className="flex items-center gap-2">
        <a
          href={`/contact/${contactId}`}
          onClick={handleViewContact}
          className="text-sm font-medium text-green-700 dark:text-green-300 hover:text-green-800 dark:hover:text-green-200 underline"
        >
          View contact
        </a>
        <button
          onClick={onDismiss}
          className="p-1 hover:bg-green-200 dark:hover:bg-green-800/30 rounded transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4 text-green-600 dark:text-green-400" />
        </button>
      </div>
    </div>
  );
};

export default ClaimedLeadBanner;
